import { useState, useEffect } from "react";
import { CountryService } from "../../services/CountryService";
import { Divider } from "primereact/divider";
import NewsTable from "../Common/NewsTable";
import { Link } from "react-router-dom";
import { AddPageHeader } from "../Common/Utils";

const DailyDatabaseReview = () => {
  const [data, setDailyDatabaseReview] = useState([]);
  const countryService = new CountryService();

  useEffect(() => {
    countryService
      .getDailyDatabaseReview()
      .then((data) => setDailyDatabaseReview(data));
  }, []);

  return (
    <div className="reduce-width">
      {AddPageHeader("Daily database review")}
      <Divider align="center">
        <h1>Daily database review</h1>
      </Divider>
      <div className="privacy-terms">
        The daily database review gathers the latest major news on diplomatic
        and consular networks, with a particular focus on the opening and
        closure of embassies, high commissions, consulates, and permanent
        missions. The review is also accessible via a dedicated{" "}
        <Link
          to="https://www.linkedin.com/showcase/the-diplomatic-and-consular-networks-database-and-rankings/"
          target="_blank"
          rel="noreferrer"
          style={{
            color: "black",
            fontWeight: "bold",
          }}
        >
          LinkedIn page
        </Link>{" "}
        and{" "}
        <Link
          to="/the-consular-newsletter"
          style={{
            color: "black",
            fontWeight: "bold",
          }}
        >
          The Consular Newsletter
        </Link>
        . Are you a recognized press body? Interested in highlighting specific
        news? Please feel free to{" "}
        <Link
          to="/contact"
          style={{
            color: "black",
            fontWeight: "bold",
          }}
        >
          contact
        </Link>{" "}
        the Center.
      </div>
      <br />
      <NewsTable data={data} searchEnabled longDescription />
    </div>
  );
};

export default DailyDatabaseReview;
